module.exports = __webpack_public_path__ + "static/media/tvshows-toddlers-icon.79464761.svg";